<template>
  <div class="side_box" :style="style">
    <table class="ref_box edit">
      <thead>
        <tr>
          <td></td>
          <td>REF</td>
          <td>B-number</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="(subpart, index) in this.parts" 
          :key="index"
        >
          <td>{{subpart.amount}}x</td>
          <td>{{subpart.ref}}</td>
          <td>{{subpart.bonID}}</td>
          <td>
            <i class="icon icon-error fas fa-times-circle"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String,
    parts: Array
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";
@import "@/style/components/lotDetailTable.scss";

.side_box {
  max-height: 440px;
}
</style>
